import * as React from "react";
import * as Yup from "yup";
import axios from "axios";
import { Formik } from "formik";
import HtmlParser from 'html-react-parser';
import { mailDomainsBlacklist } from '../utils/utils.js';
// import { globalHistory as history } from '@reach/router';

const PORTAL_ID = '7284441';
const FORM_ID = 'cd731b32-2724-4986-9f9d-f405c3d90ae7';

function toFormGroupClass(field, state, error) {
  if (state.touched[field] && (state.errors[field] || error)) {
    return "pt-form-group pt-intent-danger";
  } else if (
    state.touched[field] &&
    state.values &&
    state.values[field] !== ""
  ) {
    return "pt-form-group pt-intent-success";
  } else {
    return "pt-form-group";
  }
}

function titleToggleJS() {
  var titleToggle = document.getElementById("contactHeaderTitleContainer");
  titleToggle.classList.add("hiddenContactHeader");
  // console.log("title toggle: " + titleToggle);
}

export class DemoFormLongNoSize extends React.Component {


  state = { error: false, mailError: false, submitted: false };

  validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string()
      .email("Must be a valid email")
      .matches(mailDomainsBlacklist, "Company Email Only")
      .required("Required")

  });


  handleSubmit = async (values, { resetForm }) => {
    values.source = this.props.source ? this.props.source : HtmlParser("");

    const url = typeof window !== 'undefined' ? window.location.href : '';
    const pageTitle = typeof document !== 'undefined' ? document.title : '';

    const UTMparams = JSON.parse(sessionStorage.getItem('UTMparams'));  

    const fields = [
      {name: 'firstname', value: values.name},
      {name: 'email', value: values.email},
      {name: 'how did you hear about us?', value: values.note },
    ]

    if (UTMparams && typeof UTMparams[0] === "string" ){

      fields.push({name: UTMparams[0], value: UTMparams[1]})

    } else if (UTMparams) {

      UTMparams.forEach(property => {
        fields.push({name: property[0], value: property[1]})
      })
    }


    const context = {
      pageUri: url,
      pageName: pageTitle
    }

    try {
      // ============ Sending to Hubspot ============ // 
      await axios.request({
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_ID}`,
        data: JSON.stringify({
          fields: fields,
          context: context
        })
      })
      
      this.setState({ submitted: true });
    
    } catch (error) {
      this.setState({ error: true })
      return
    }

    // ============ Sending to Charthop API (Slack) ============ //
    await axios.request({
      method: "POST",
      url: "https://api.charthop.com/contact",
      data: {...values}
    })

  };

  render() {

    const headertext = this.props.headertext ? this.props.headertext : HtmlParser("Hop to the future of your <br/><br>Request a demo.");
    // const focusID = this.props.focusID ? this.props.focusID : HtmlParser("name");
    // const sourceValue = this.props.source ? this.props.source : HtmlParser("");


    // const firstCheckbox = this.props.firstCheckbox ? this.props.firstCheckbox : HtmlParser("");
    // const secondCheckbox = this.props.secondCheckbox ? this.props.secondCheckbox : HtmlParser("");

    if (this.state.submitted) {
      var elmnt = document.getElementById("request-demo");
      elmnt.scrollIntoView(true);
      return (

        <div className="pt-callout pt-intent-primary pt-submission-success">
          <img src={'/home/successfulFormSubmission.svg'} alt="The ChartHop logo" />
          <p>Thanks for your interest in ChartHop!</p>
          <p>We'll be in touch soon.</p>
          {titleToggleJS()}
        </div>

      );
    }

    return (

      <div className="container">
        <div className="row align-items-top justify-content-around ">

          <div id="contactHeaderTitleContainer" className="contactHeaderTitleContainer d-flex col-md-5 col-lg-5 offset-lg-2 col-xs-12 mb-1 mb-md-0 ">
            {headertext}
          </div>

          <div className="longFormParentContainer col-md-5 col-lg-5 col-xs-12" >
            <Formik
              initialValues={{ name: "", email: "", note: "", source: "" }}
              validationSchema={this.validationSchema}
              onSubmit={this.handleSubmit}
              render={form => (

                <form
                  className="demolongform"
                  onSubmit={form.handleSubmit}
                >

                  <div className={toFormGroupClass("name", form)}>
                    <label className="pt-label" htmlFor="name">
                      {/* Full Name */}
                    </label>
                    <input
                      placeholder="Full Name"

                      id="name"
                      type="text"
                      className="pt-input focusInputElement"
                      value={form.values.name}
                      onChange={form.handleChange}
                    // placeholder="Full Name"
                    />
                    {form.touched.name && form.errors.name && (
                      <div className="pt-form-helper-text">{form.errors.name}</div>
                    )}
                  </div>

                  <div className={toFormGroupClass("email", form)} >
                    <label className="pt-label" htmlFor="email">
                      {/* Company Email */}
                    </label>
                    <input
                      placeholder="Company Email"
                      id="email"
                      type="email"
                      value={form.values.email}
                      onChange={form.handleChange}
                    // placeholder="Company Email"
                    />
                    {form.touched.email && form.errors.email && (
                      <div className="pt-form-helper-text">{form.errors.email}</div>
                    )}

                  </div>

                  <div className="pt-form-group">
                    <label className="pt-label" htmlFor="note">
                      {/* How did you hear about us? */}
                    </label>
                    <input
                      type="text"
                      id="note"
                      value={form.values.note}
                      onChange={form.handleChange}
                      placeholder="How did you hear about us?"
                    />
                  </div>

                  <p className="opt-in pt-0 pb-0 mb-0">By requesting a demo, you agree to opt-in to emails from ChartHop.</p>


                  <button ref={btn => { this.btn = btn; }} type="submit" className="button primary">
                    REQUEST ACCESS
                  </button>

                  {this.state.mailError && (
                    <div className="pt-callout pt-intent-danger" style={{ marginTop: 10 }}>
                      Sorry! Please use a company email. If your issue persists, send a note to {" "}
                      <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                    </div>
                  )}

                  {this.state.error && (
                    <div
                      className="pt-callout pt-intent-danger"
                      style={{ marginTop: 10 }}
                    >
                      Sorry, but we had an unexpected problem submitting your request.
                Try again later, or send a note to{" "}
                      <a href="mailto:hello@charthop.com">hello@charthop.com</a>.
                    </div>
                  )}
                </form>

              )}
            />
          </div>

        </div>
      </div>
    );
  }
} 